/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_InactiveInputs */

const de__field_inactive = /** @type {(inputs: _Field_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaktiv in der Lernförderung`)
};

/**

* @param {_Field_InactiveInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_inactive = /** @type {((inputs?: _Field_InactiveInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_InactiveInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_inactive(inputs)
});